import { render } from "./MagnifyingGlassComponent.vue?vue&type=template&id=83a856de&scoped=true"
import script from "./MagnifyingGlassComponent.vue?vue&type=script&lang=js"
export * from "./MagnifyingGlassComponent.vue?vue&type=script&lang=js"

import "./MagnifyingGlassComponent.vue?vue&type=style&index=0&id=83a856de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a856de"]])

export default __exports__